import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateType extends Enum {
  key!: string;
  value!: string;
  productType?: string;
  filterName!: string;
  icon!: string;

  static CLEAR_VAULT: EstateType = {
    key: 'clear_vault',
    get value(): string {
      return Lang.t('estate.clear-vault');
    },
    get productType(): string {
      return Lang.t('estate.vault');
    },
    get filterName(): string {
      return Lang.t('Planning');
    },
    icon: 'saving-piggy-dollars'
  };

  static CLEAR_ESTATE: EstateType = {
    key: 'clear_estate',
    get value(): string {
      return Lang.t('estate.clear-estate');
    },
    get productType(): string {
      return Lang.t('accounting.estate');
    },
    get filterName(): string {
      return Lang.t('Settlement');
    },
    icon: 'flower'
  };

  static CLEAR_WILL: EstateType = {
    key: 'clear_will',
    get value(): string {
      return Lang.t('estate.clear-will');
    },
    get filterName(): string {
      return Lang.t('Will');
    },
    icon: 'common-file-award'
  };
}
